// Define the legacy integration types
export enum LegacyIntegrationType {
  FACEBOOK = 'facebook',
  GOOGLEPLUS = 'googleplus',
  GOOGLEMEET = 'GoogleMeet',
  ZOOMMEET = 'ZoomMeet',
  QUICKBOOKS = 'quickbooks',
  INSTAGRAM = 'instagram',
}

// Use the IntegrationType union to define the keys of the SocialConnectionLinks interface
export type SocialConnectionLinks = {
  [key in LegacyIntegrationType]: string;
};
